import { useCallback, useMemo } from "react"
import strappedConnected from "modules/Core/higher-order-components/strappedConnected";
import withRecursiveRender from "modules/Core/higher-order-components/withRecursiveRender";
import cells from "modules/cycles/state";
import feed from "modules/cycles/state/feed";
import { isPlaceholderActivity, isSabbaticalActivity } from "modules/cycles/consts";
import CycleActivity, { CycleSabbatical } from "../CycleActivity";
import EmptyActivityCard from "../EmptyActivityCard";
import withActivityCardWrapper from "./withActivityCardWrapper";

const C = withRecursiveRender({
    placeholder: withRecursiveRender({
        feedItem: EmptyActivityCard,
    }, withActivityCardWrapper(EmptyActivityCard)),
    sabbatical: withRecursiveRender({
        feedItem: CycleSabbatical,
    }, withActivityCardWrapper(CycleSabbatical)),
    feedItem: CycleActivity,
}, withActivityCardWrapper(CycleActivity));

export default strappedConnected(
    C,
    {},
    {
        reorder: cells.reorderCycleActivity.action,
        refetchEntity: feed.cells.fetchEntity.action,
        remove: cells.removeActivityFromCycle.action
    },
    ({ activity, cycleId, index, flowLength, reorder, refetchEntity, remove, onRefetch }) => ({
        placeholder: isPlaceholderActivity(activity),
        sabbatical: isSabbaticalActivity(activity),
        reorder: (moveUp) => reorder({ cycleId, activityId: activity?.id, moveUp }),
        hideUp: useMemo(() => index === 0, [index]),
        hideDown: useMemo(() => index === flowLength - 1, [index, flowLength]),
        refetch: useCallback(() => {
            if (onRefetch) return onRefetch();
            return refetchEntity({ id: cycleId, overwrite: true });
        }, [onRefetch, refetchEntity, cycleId]),
        remove: useCallback(() => remove({ cycleId, activityId: activity?.id }), [activity?.id, remove, cycleId])
    })
)
